<xemex-page-header
  [title]="'sidebarMenu.firmwareManagement' | translate"
  [breadcrumbs]="[{ label: 'sidebarMenu.home' | translate, routerLink: '/devices' }, { label: 'sidebarMenu.firmwareManagement' | translate }]"
>
  <div actions class="flex items-center gap-x-2">
    @if (selectedCount > 0) {
      <span class="selection-badge">
        {{ 'firmwareManagement.bulkUpdate.selectedCount' | translate: { count: selectedCount } }}
      </span>
      <xemex-text-button type="button" (click)="selectedDevices.set([])">
        {{ 'firmwareManagement.bulkUpdate.clearSelection' | translate }}
      </xemex-text-button>
      <xemex-filled-button type="button" (click)="onBulkUpdateClicked()">
        {{ 'firmwareManagement.bulkUpdate.bulkUpdateButton' | translate }}
      </xemex-filled-button>
    }
    <a
      [routerLink]="['/', APP_PATHS.Settings, 'firmware-versions']"
      class="text-primary hover:underline"
    >
      {{ 'firmwareManagement.viewFirmwareVersions' | translate }}
    </a>
    <button
      type="button"
      mat-icon-button
      color="primary"
      (click)="onRefreshClicked()"
      [disabled]="deviceStore.isLoading()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</xemex-page-header>

<xemex-page-body>
  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [loading]="deviceStore.isLoading()"
    [totalCount]="totalCount()"
    [selectable]="true"
    [clickableRows]="true"
    (pageChange)="onPageChange($event)"
    (selectedRows)="onSelectedRowsChange($event)"
    (rowClick)="onRowClick($event)"
  >
    <xemex-table-filter-bar
      [filterGroups]="filterGroups()"
      [showSearch]="false"
      (filterChange)="onFilterChange($event)"
    ></xemex-table-filter-bar>

    <ng-template #actionsCell let-row>
      @if (row['firmwareStatusKey'] === 'Update available') {
        <xemex-text-button type="button" (click)="onRowClick(row)">
          {{ 'firmwareManagement.updateButton' | translate }}
        </xemex-text-button>
      }
    </ng-template>
  </xemex-table>
</xemex-page-body>
